import { Component, OnInit, OnDestroy, Input } from '@angular/core';

import { ISubscription } from 'rxjs/Subscription';

import Handsontable from 'handsontable';
import { HotRegisterer } from 'angular-handsontable';

import {Report} from '../shared/report.model';
import {ReportDataService} from '../report-data.service';


@Component({
  selector: 'app-configuration',
  templateUrl: './configuration.component.html',
  styleUrls: ['./configuration.component.css']
})
export class ConfigurationComponent implements OnInit, OnDestroy {
  columns: Array<Object>;
  rowHeaders: Array<String>;
  report: Report;
  data: any;
  reloadSubscription: ISubscription;

  constructor(private reportService: ReportDataService, private gridContext: HotRegisterer) {
  }

  ngOnInit() {
    this.report = this.reportService.getReport();
//    this.columns = this.report.ReportConfiguration.columns;
    this.columns = [
      {title: 'Value', data: 'Value', type: 'checkbox'}
    ];
    this.rowHeaders = this.report.ReportConfiguration.rowHeaders;
    this.data = this.report.ReportConfiguration.data;
    this.reloadSubscription = this.reportService.getReload().subscribe(data => this.reload());
  }

  ngOnDestroy() {
    this.reloadSubscription.unsubscribe();
  }

  reload() {
    this.data = this.report.ReportConfiguration.data;
    const gridInstance = this.gridContext.getInstance('Configuration');
    gridInstance.loadData(this.data);
  }

}



// WEBPACK FOOTER //
// ./src/app/configuration/configuration.component.ts